module.exports = __webpack_public_path__ + "f0e8340ee4396ff57d97073eeab73a28.jpg";